import React from 'react';
const DownIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <g clipPath="url(#clip0_350_7006)">
            <path fillRule="evenodd" clipRule="evenodd" d="M12.707 15.7064C12.5194 15.8938 12.2651 15.9992 12 15.9992C11.7348 15.9992 11.4805 15.8938 11.293 15.7064L5.63598 10.0494C5.54047 9.95712 5.46428 9.84678 5.41188 9.72477C5.35947 9.60277 5.33188 9.47155 5.33073 9.33877C5.32957 9.20599 5.35487 9.07431 5.40516 8.95141C5.45544 8.82852 5.52969 8.71686 5.62358 8.62297C5.71747 8.52908 5.82913 8.45483 5.95202 8.40454C6.07492 8.35426 6.2066 8.32896 6.33938 8.33012C6.47216 8.33127 6.60338 8.35886 6.72538 8.41126C6.84739 8.46367 6.95773 8.53986 7.04998 8.63537L12 13.5854L16.95 8.63537C17.1386 8.45321 17.3912 8.35241 17.6534 8.35469C17.9156 8.35697 18.1664 8.46214 18.3518 8.64755C18.5372 8.83296 18.6424 9.08377 18.6447 9.34597C18.6469 9.60816 18.5461 9.86076 18.364 10.0494Z" fill="black"/>
        </g>
        <defs>
            <clipPath id="clip0_350_7006">
                <rect width="24" height="24" fill="white"/>
            </clipPath>
        </defs>
    </svg>
);

export default DownIcon;